import React from 'react'
import { Row } from 'antd'
import moment from 'moment'
import { useTranslation } from 'next-i18next'
import { useWindowSize } from 'src/app/hooks'
import { CustomCol, CustomText, CustomDatePicker } from 'src/components'

const CustomDateRangeInput: React.FC<{ rigthCol?: number }> = ({ rigthCol = 11 }) => {
  const { t } = useTranslation()
  const { isMobile } = useWindowSize()

  return <Row>
    <CustomCol lg={11}>

      {/* Discount Date Start */}
      <CustomText label={t('Discount.DateStart')} />
      <CustomDatePicker
        name='date_start'
        placeholder={t('Projects.Form.DatePlaceholder')}
        required
      />
    </CustomCol>
    <CustomCol lg={rigthCol} className={!isMobile && 'ml-5'}>

      {/* Discount Date End */}
      <CustomText label={t('Discount.DateEnd')} />
      <CustomDatePicker
        name='date_end'
        placeholder={t('Projects.Form.DatePlaceholder')}
        required
        otherRules={[
          ({ getFieldValue }) => ({
            validator(_, date_end: moment.Moment) {
              const date_start = getFieldValue('date_start')
              if (!date_start) { return Promise.reject(new Error(t('Discount.DateError1'))) }
              if (date_start.isBefore(date_end)) { return Promise.resolve() }
              if (date_start) { return Promise.reject(new Error(t('Discount.DateError2'))) }
              return Promise.resolve()
            },
          })
        ]}
      />
    </CustomCol>
  </Row>
}

export default CustomDateRangeInput
